import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'ota-booking-details-roomtype-item',
  templateUrl: './roomtype-item.component.html',
  styleUrls: ['./roomtype-item.component.scss']
})
export class RoomtypeItemComponent implements OnInit {
  @Input('isOpen') isOpen: boolean = true;
  @Input('data-index') itemIndex: number;

  constructor() {}

  ngOnInit() {}

  toggleContent() {
    this.isOpen = !this.isOpen;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/roomtype-item/roomtype-item.component.ts